import React from 'react';
import { useWidgetPlugin } from './useWidgetPlugin';
import classes from '../slotsPlaceholder.scss';
import { useSlotHighlighting } from './useSlotHighlighting';
import { useSlotUniqueId } from './useSlotUniqueId';
const PlaceholderWrapper = ({ PluginComponent, isEmpty, isHighlighted, slotUniqueId }) => (React.createElement("div", { id: slotUniqueId, "data-hook": `slot-placeholder-${slotUniqueId}`, className: isHighlighted ? classes.slotHighlighted : '' }, !isEmpty && React.createElement(PluginComponent, null)));
export const useSlotPlaceholder = (slotId) => {
    const { PluginComponent, isEmpty } = useWidgetPlugin(slotId);
    const isHighlighted = useSlotHighlighting(slotId);
    const slotUniqueId = useSlotUniqueId(slotId);
    const Placeholder = React.useCallback(() => (React.createElement(PlaceholderWrapper, { slotUniqueId: slotUniqueId, isHighlighted: isHighlighted, isEmpty: isEmpty, PluginComponent: PluginComponent })), [slotUniqueId, isHighlighted, isEmpty, PluginComponent]);
    return [Placeholder, isEmpty];
};
//# sourceMappingURL=useSlotPlaceholder.js.map